var React = require('react');

function Star (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_427_9719)","key":0},React.createElement("path",{"d":"M8.49957 0.628143L10.7307 5.15076L15.7257 5.8794L12.1126 9.39699L12.9619 14.3719L8.49957 12.0251L4.03223 14.3719L4.8865 9.39699L1.27344 5.8794L6.26841 5.15076L8.49957 0.628143Z","stroke":"#CF2029","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_427_9719"},React.createElement("rect",{"width":"15.7085","height":"15","fill":"white","transform":"translate(0.645508)"})))]);
}

Star.defaultProps = {"width":"17","height":"15","viewBox":"0 0 17 15","fill":"none"};

module.exports = Star;

Star.default = Star;
